import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { EditableLabelGroup, WrappingBehavior, ILabelModel } from "azure-devops-ui/Label";
import { ObservableArray } from "azure-devops-ui/Core/Observable";
export default class EditableLabelGroupSingleLine extends React.Component<{}> {
    private ref: React.RefObject<EditableLabelGroup> = React.createRef<EditableLabelGroup>();

    public render() {
        return (
            <div className="flex-column" style={{ width: 400 }}>
                <EditableLabelGroup
                    ref={this.ref}
                    labelProps={labelProps}
                    wrappingBehavior={WrappingBehavior.oneLine}
                    getSuggestedLabels={getSuggestions}
                    title={"Labels"}
                    onLabelSubmit={this.onLabelSubmit}
                    onLabelRemove={this.onLabelRemove}
                />
                <Button onClick={this.onButtonClick}>Click to focus</Button>
            </div>
        );
    }

    private onLabelSubmit = (model: ILabelModel) => {
        labelProps.push(model);
    };

    private onLabelRemove = (model: ILabelModel) => {
        labelProps.removeAll(
            (item: ILabelModel) => item.content.toUpperCase() === model.content.toUpperCase()
        );
    };

    private onButtonClick = () => {
        this.ref.current!.focus();
    };
}

const getSuggestions = (context: string) => {
    const items: ILabelModel[] = [
        {
            content: "Bug Bash 0.17",
            color: {
                red: 0,
                green: 255,
                blue: 0
            }
        },
        {
            content: "Bug Bash 0.28",
            color: {
                red: 255,
                green: 0,
                blue: 0
            }
        },
        {
            content: "Accessibility",
            color: {
                red: 0,
                green: 0,
                blue: 255
            }
        }
    ];

    return items.filter(x => x.content.toLowerCase().indexOf(context.toLowerCase()) == 0);
};

const labelProps: ObservableArray<ILabelModel> = new ObservableArray<ILabelModel>([
    {
        content: "Label Content"
    },
    {
        content: "Lorem ipsum dolor sit amet consectetur"
    },
    {
        content: "Custom color!",
        color: {
            red: 0,
            green: 255,
            blue: 0
        }
    },
    {
        content: "Dark invert text",
        color: {
            red: 0,
            green: 0,
            blue: 0
        }
    },
    {
        content: "Less dark invert",
        color: {
            red: 50,
            green: 50,
            blue: 128
        }
    }
]);
